var RulesJS = RulesJS || {};

RulesJS.VariantSelector = function() {

    var _masterVariantSelector = $('.variant-selector');
    var _submitBtn = $('.shopify-product-form input[type="submit"]');

    var _init = function() {

        // only continue if product template
        if (!$('body').hasClass('template--product')) {
            return;
        }

        // handle clicks on production option selector buttons
        $('.product-option-select').on('change', function(e) {
            let option = $(this);
            _updateOtherOptions(option);
            _updateMasterVariantSelector();
        });

        // store current selection
        // let selectedMasterVariant = _masterVariantSelector.find(':selected').val();
        // _selection['option1'] = selectedMasterVariant.data('option1');
        // _selection['option2'] = selectedMasterVariant.data('option2');
        // _selection['option3'] = selectedMasterVariant.data('option3');

        // $('.my-class[data-id="' + dataId + '"][data-id-index="'+dataIdIndex+'"]')



        // update selected option in master variant selector
        // _masterVariantSelector.find(':selected').prop("selected", false);
        // _masterVariantSelector.find('option[data-option1="' + dataId + '"][data-option2="'+dataIdIndex+'"]');
    }

    var _updateOtherOptions = function(option) {
        let selector = option.hasClass('product-option-select--opt1') ? '.product-option-select--opt2' : '.product-option-select--opt1';
        let availableOpts = option.data('available-opts').split('|');

        $(selector).each(function() {
            let otherOption = $(this)
            let otherOptionValue = otherOption.val();
            let label = otherOption.next('label');
            let labelText = label.text();

            if (availableOpts.indexOf(otherOptionValue) > -1) {
                if (label.hasClass('btn-outline-secondary')) {
                    label
                        .addClass('btn-outline-primary')
                        .removeClass('btn-outline-secondary')
                        .html(labelText);
                }
            } else {
                if (label.hasClass('btn-outline-primary')) {
                    label
                        .addClass('btn-outline-secondary')
                        .removeClass('btn-outline-primary')
                        .html('<del>' + labelText + '<del>');
                }
            }
        });
    }

    var _updateMasterVariantSelector = function() {
        // read option selectors
        let option1Val = $("input:radio[name='option1']:checked").val();
        let option2Val = _masterVariantSelector.data('option2');;
        // let option3Val = $("input:radio[name='option3']:checked").val();

        // deselect previous selected variant in master variant selector
        _masterVariantSelector.find(':selected').prop("selected", false);

        // select new variant in master variant selector
        // let newMasterVariant = _masterVariantSelector.find('option[data-option1="' + option1Val + '"][data-option2="' + option2Val + '"][data-option3="' + option3Val + '"]');
        let newMasterVariant = _masterVariantSelector.find('option[data-option1="' + option1Val + '"][data-option2="' + option2Val + '"]');
        newMasterVariant.prop('selected', true);

        console.log(option1Val);
        console.log(option2Val);

        // update submit button based on variant availability
        if (newMasterVariant.data('available')) {
            _submitBtn.addClass('btn-outline-primary').removeClass('btn-outline-light').prop('disabled', false).prop('value', _submitBtn.data('label-available'));
        } else {
            _submitBtn.addClass('btn-outline-light').removeClass('btn-outline-primary').prop('disabled', true).prop('value', _submitBtn.data('label-soldout'));
        }
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();}
    };

}();

$(function() {
    RulesJS.VariantSelector.init();
});
